import {
  // AudioOutlined,
  AuditOutlined,
  // BuildOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  ContactsOutlined,
  ContainerOutlined,
  DashboardOutlined,
  FileImageOutlined,
  FireOutlined,
  // FileProtectOutlined,
  FormOutlined,
  HomeOutlined,
  InfoCircleOutlined,
  LockOutlined,
  SoundOutlined,
  // SmileOutlined,
  SnippetsOutlined,
  RadarChartOutlined,
  FieldTimeOutlined,
  MoreOutlined,
  UnorderedListOutlined,
  ClusterOutlined,
  ExceptionOutlined,
  // MenuOutlined,
  DatabaseOutlined,
  ShrinkOutlined,
  TagsOutlined,
  ToolOutlined,
  UserOutlined,
  VideoCameraOutlined,
  SettingOutlined,
  ProfileOutlined,
  RobotOutlined,
  MessageOutlined,
  DislikeOutlined,
  LikeOutlined,
  QuestionCircleOutlined,
  UserOutlined as UserIconOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import { MODULES } from "constants/ModulesConstant";
import { PERMISSIONS } from "constants/PermissionConstant";

const dashBoardNavTree = [
  {
    key: "dashboard",
    path: `${APP_PREFIX_PATH}/dashboard`,
    title: "dashboard",
    icon: DashboardOutlined,
    breadcrumb: true,
    submenu: [],
  },
];
const homeNavTree = [
  {
    key: "home",
    path: `${APP_PREFIX_PATH}/home`,
    title: "home",
    icon: HomeOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "banner-details",
        path: `${APP_PREFIX_PATH}/home/banner-details/list`,
        title: "banner.details",
        breadcrumb: true,
        moduleKey: MODULES.EGYPT_STATISTICS_JOURNALS,
        permissionId: PERMISSIONS.SHOW,
        icon: "",
        submenu: [],
      },
      // {
      //   key: "home-page-indicator",
      //   path: `${APP_PREFIX_PATH}/home/indicator/list`,
      //   title: "home.page.indicator",
      //   breadcrumb: true,
      //   icon: "",
      //   submenu: [],
      // },
      {
        key: "population-list",
        path: `${APP_PREFIX_PATH}/population/list`,
        title: "population",
        breadcrumb: false,
        moduleKey: MODULES.EGYPT_STATISTICS_JOURNALS,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "home-news-tab-bar",
        path: `${APP_PREFIX_PATH}/home/news-tab-bar/list`,
        title: "news.tab.bar",
        breadcrumb: true,
        moduleKey: MODULES.NEWS_BAR,
        permissionId: PERMISSIONS.SHOW,
        icon: "",
        submenu: [],
      },
    ],
  },
];
const adminNavTree = [
  {
    key: "others",
    path: `${APP_PREFIX_PATH}`,
    title: "others",
    icon: MoreOutlined,
    breadcrumb: false,
    submenu: [
      // {
      //   key: "journals-news",
      //   path: `${APP_PREFIX_PATH}/journals`,
      //   title: "journals",
      //   icon: ContainerOutlined,
      //   breadcrumb: false,
      //   submenu: [
      //     {
      //       key: "journals-category-list",
      //       path: `${APP_PREFIX_PATH}/journals/list`,
      //       title: "journals.category.list",
      //       breadcrumb: true,
      //       moduleKey: MODULES.JOURNAL_CATEGORY,
      //       permissionId: PERMISSIONS.SHOW,
      //       icon: "",
      //       submenu: [],
      //     },
      //     {
      //       key: "journals-news-list",
      //       path: `${APP_PREFIX_PATH}/journals/news/list`,
      //       title: "journals.news.list",
      //       breadcrumb: true,
      //       moduleKey: MODULES.JOURNALISM,
      //       permissionId: PERMISSIONS.SHOW,
      //       icon: "",
      //       submenu: [],
      //     },
      //   ],
      // },

      {
        key: "related-website",
        path: `${APP_PREFIX_PATH}/related-websites`,
        title: "related.website",
        icon: ContainerOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "website-type-list",
            path: `${APP_PREFIX_PATH}/related-websites-type/list`,
            title: "related.website.type",
            breadcrumb: true,
            moduleKey: MODULES.WEBSITE_TYPE,
            permissionId: PERMISSIONS.SHOW,
            icon: "",
            submenu: [],
          },
          {
            key: "related-website-list",
            path: `${APP_PREFIX_PATH}/related-websites/list`,
            title: "related.website.list",
            breadcrumb: true,
            moduleKey: MODULES.RELATED_WEBSITE,
            permissionId: PERMISSIONS.SHOW,
            icon: "",
            submenu: [],
          },
        ],
      },
      {
        key: "event",
        path: `${APP_PREFIX_PATH}/event`,
        title: "event",
        icon: CalendarOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "event-list",
            path: `${APP_PREFIX_PATH}/event/list`,
            title: "event.list",
            breadcrumb: true,
            moduleKey: MODULES.CALENDARS,
            permissionId: PERMISSIONS.SHOW,
            icon: "",
            submenu: [],
          },
          {
            key: "event-type-list",
            path: `${APP_PREFIX_PATH}/event-type/list`,
            title: "event.type",
            breadcrumb: true,
            moduleKey: MODULES.EVENT_TYPES,
            permissionId: PERMISSIONS.SHOW,
            icon: "",
            submenu: [],
          },
        ],
      },
      {
        key: "international-day",
        path: `${APP_PREFIX_PATH}/international-day/list`,
        title: "international.days",
        icon: CalendarOutlined,
        breadcrumb: false,
        moduleKey: MODULES.INTERNATIONAL_DAYS,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      // {
      //   key: "training-program",
      //   path: `${APP_PREFIX_PATH}/training-program`,
      //   title: "training.program",
      //   icon: FileProtectOutlined,
      //   breadcrumb: false,
      //   submenu: [
      //     {
      //       key: "training-program-list",
      //       path: `${APP_PREFIX_PATH}/training-program/list`,
      //       title: "training.program.list",
      //       breadcrumb: true,
      //       moduleKey: MODULES.TRAINING_PROGRAM,
      //       permissionId: PERMISSIONS.SHOW,
      //       icon: "",
      //       submenu: [],
      //     },
      //   ],
      // },

      {
        key: "footer",
        path: `${APP_PREFIX_PATH}/footer`,
        title: "footer",
        icon: CalendarOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "selected-pages-list",
            path: `${APP_PREFIX_PATH}/footer/selectedPages/list`,
            title: "selected.pages.list",
            breadcrumb: false,
            moduleKey: MODULES.FOOTER,
            permissionId: PERMISSIONS.SHOW,
            icon: "",
            submenu: [],
          },
          {
            key: "contact.us",
            path: `${APP_PREFIX_PATH}/footer/contactUs`,
            title: "contact.us",
            breadcrumb: false,
            moduleKey: MODULES.FOOTER,
            permissionId: PERMISSIONS.SHOW,
            icon: "",
            submenu: [],
          },
          {
            key: "footer-social-link",
            path: `${APP_PREFIX_PATH}/footer/social-links`,
            title: "social.media.links",
            moduleKey: MODULES.SOCIAL_LINK,
            permissionId: PERMISSIONS.SHOW,
            breadcrumb: false,
            // moduleKey: MODULES.FOOTER,
            // permissionId: PERMISSIONS.SHOW,
            icon: "",
            submenu: [],
          },
        ],
      },

      // {
      //   key: "page-builder",
      //   path: `${APP_PREFIX_PATH}/page-builder`,
      //   title: "page.builder",
      //   icon: BuildOutlined,
      //   breadcrumb: false,
      //   submenu: [
      //     {
      //       key: "page-builder-list",
      //       path: `${APP_PREFIX_PATH}/page-builder/list`,
      //       title: "page.builder.list",
      //       breadcrumb: true,
      //       icon: "",
      //       submenu: [],
      //     },
      //     {
      //       key: "page-builder-add",
      //       path: `${APP_PREFIX_PATH}/page-builder/add`,
      //       title: "page.builder.add",
      //       breadcrumb: false,
      //       icon: "",
      //       submenu: [],
      //     },
      //   ],
      // },
      // {
      //   key: "menu-builder",
      //   path: `${APP_PREFIX_PATH}/menu-builder`,
      //   title: "menu.builder",
      //   icon: MenuOutlined,
      //   breadcrumb: false,
      //   submenu: [
      //     {
      //       key: "menu-builder-list",
      //       path: `${APP_PREFIX_PATH}/menu-builder/list`,
      //       title: "menu.builder.list",
      //       breadcrumb: true,
      //       icon: "",
      //       submenu: [],
      //     },
      //     {
      //       key: "menu-builder-add",
      //       path: `${APP_PREFIX_PATH}/menu-builder/add`,
      //       title: "menu.builder.add",
      //       breadcrumb: false,
      //       icon: "",
      //       submenu: [],
      //     },
      //   ],
      // },
    ],
  },
];

const mediaCenterTree = [
  {
    key: "media-center",
    path: `${APP_PREFIX_PATH}`,
    title: "media.center",
    icon: FileImageOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "photo-media",
        path: `${APP_PREFIX_PATH}/photo-media`,
        title: "photo.library",
        icon: FileImageOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "photo-media-category-list",
            path: `${APP_PREFIX_PATH}/photo-media-category/list`,
            title: "photo.library.category",
            breadcrumb: true,
            moduleKey: MODULES.PHOTO_CATEGORY,
            permissionId: PERMISSIONS.SHOW,
            icon: "",
            submenu: [],
          },
          {
            key: "photo-media-list",
            path: `${APP_PREFIX_PATH}/photo-media/list`,
            title: "photo.library.list",
            breadcrumb: true,
            moduleKey: MODULES.PHOTO,
            permissionId: PERMISSIONS.SHOW,
            icon: "",
            submenu: [],
          },
        ],
      },

      {
        key: "video-library",
        path: `${APP_PREFIX_PATH}/video-library`,
        title: "video.library",
        icon: VideoCameraOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "video-library-category-list",
            path: `${APP_PREFIX_PATH}/video-library-category/list`,
            title: "video.library.category",
            breadcrumb: true,
            moduleKey: MODULES.VIDEO_LIBRARY_CATEGORY,
            permissionId: PERMISSIONS.SHOW,
            icon: "",
            submenu: [],
          },
          {
            key: "video-library-list",
            path: `${APP_PREFIX_PATH}/video-library/list`,
            title: "video.library.list",
            breadcrumb: true,
            moduleKey: MODULES.VIDEO_LIBRARY,
            permissionId: PERMISSIONS.SHOW,
            icon: "",
            submenu: [],
          },
        ],
      },
      {
        key: "radio",
        path: `${APP_PREFIX_PATH}/radio`,
        title: "radio",
        icon: SoundOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "radio-category-list",
            path: `${APP_PREFIX_PATH}/radio-category/list`,
            title: "radio.category",
            breadcrumb: true,
            moduleKey: MODULES.RADIO_LIBRARY_CATEGORY,
            permissionId: PERMISSIONS.SHOW,
            icon: "",
            submenu: [],
          },
          {
            key: "radio-list",
            path: `${APP_PREFIX_PATH}/radio/list`,
            title: "radio.list",
            breadcrumb: true,
            moduleKey: MODULES.RADIO_LIBRARY,
            permissionId: PERMISSIONS.SHOW,
            icon: "",
            submenu: [],
          },
        ],
      },
      {
        key: "news",
        path: `${APP_PREFIX_PATH}/news`,
        title: "news",
        icon: AuditOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "news-category-list",
            path: `${APP_PREFIX_PATH}/news-category/list`,
            title: "news.category",
            breadcrumb: true,
            moduleKey: MODULES.NEWS_CATEGORIES,
            permissionId: PERMISSIONS.SHOW,
            icon: "",
            submenu: [],
          },
          {
            key: "news-list",
            path: `${APP_PREFIX_PATH}/news/list`,
            title: "news.list",
            breadcrumb: true,
            moduleKey: MODULES.NEWS,
            permissionId: PERMISSIONS.SHOW,
            icon: "",
            submenu: [],
          },
          {
            key: "publication.news",
            path: `${APP_PREFIX_PATH}/publication-news/list`,
            title: "publication.news",
            breadcrumb: true,
            moduleKey: MODULES.PUBLICATION_NEWS,
            permissionId: PERMISSIONS.SHOW,
            icon: "",
            submenu: [],
          },
        ],
      },
      {
        key: "tags-list",
        path: `${APP_PREFIX_PATH}/tags/list`,
        title: "tags",
        breadcrumb: true,
        moduleKey: MODULES.Tags,
        permissionId: PERMISSIONS.SHOW,
        icon: TagsOutlined,
        submenu: [],
      },
      {
        key: "magazine-list",
        path: `${APP_PREFIX_PATH}/magazine/list`,
        title: "magazine.list",
        breadcrumb: true,
        moduleKey: MODULES.EGYPT_STATISTICS_JOURNALS,
        permissionId: PERMISSIONS.SHOW,
        icon: AuditOutlined,
        submenu: [],
      },
    ],
  },
];
const aboutCapmasTree = [
  {
    key: "about-capmas",
    path: `${APP_PREFIX_PATH}/about-capmas`,
    title: "about.us",
    icon: InfoCircleOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "about-capmas-vision",
        path: `${APP_PREFIX_PATH}/about-capmas/vision`,
        title: "vision.and.mission",
        moduleKey: MODULES.MISSION_VISION,
        permissionId: PERMISSIONS.SHOW,
        breadcrumb: true,
        icon: "",
        submenu: [],
      },
      {
        key: "about-capmas-main-measurments",
        path: `${APP_PREFIX_PATH}/about-capmas/main-measurments`,
        title: "main.measurments",
        moduleKey: MODULES.MAIN_VALUE,
        permissionId: PERMISSIONS.SHOW,
        breadcrumb: true,
        icon: "",
        submenu: [],
      },
      {
        key: "about-capmas-head",
        path: `${APP_PREFIX_PATH}/about-capmas/head`,
        title: "capmas.heads",
        breadcrumb: true,
        moduleKey: MODULES.CAPMAS_HEAD,
        permissionId: PERMISSIONS.SHOW,
        icon: "",
        submenu: [],
      },
      {
        key: "about-capmas-organization-structure",
        path: `${APP_PREFIX_PATH}/about-capmas/organization-structure`,
        title: "capmas.organization.structure",
        breadcrumb: true,
        moduleKey: MODULES.ORGANIZATION_HIERARCHY,
        permissionId: PERMISSIONS.EDIT,
        icon: "",
        submenu: [],
      },
      {
        key: "about-capmas-sectors",
        path: `${APP_PREFIX_PATH}/about-capmas/sector`,
        title: "sectors",
        breadcrumb: true,
        moduleKey: MODULES.SECTOR,
        permissionId: PERMISSIONS.SHOW,
        icon: "",
        submenu: [],
      },
      {
        key: "about-capmas-history",
        path: `${APP_PREFIX_PATH}/about-capmas/history`,
        title: "history",
        breadcrumb: true,
        moduleKey: MODULES.CAPMAS_HISTORY,
        permissionId: PERMISSIONS.SHOW,
        icon: "",
        submenu: [],
      },
      {
        key: "about-capmas-law-regulation",
        path: `${APP_PREFIX_PATH}/about-capmas/law-regulation`,
        title: "law.regulation",
        breadcrumb: true,
        moduleKey: MODULES.LAW_REGULATION,
        permissionId: PERMISSIONS.SHOW,
        icon: "",
        submenu: [],
      },
      {
        key: "about-capmas-terms-conditions",
        path: `${APP_PREFIX_PATH}/about-capmas/terms-conditions`,
        title: "terms.conditions",
        breadcrumb: true,
        moduleKey: MODULES.USAGE_RIGHT_AND_TERMS,
        permissionId: PERMISSIONS.SHOW,
        icon: "",
        submenu: [],
      },
    ],
  },
];
const contactUsTree = [
  {
    key: "contact-us",
    path: `${APP_PREFIX_PATH}/regional-office`,
    title: "contact.us",
    icon: ContactsOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "regional-office-list",
        path: `${APP_PREFIX_PATH}/regional-office/list`,
        title: "regional.offices.list",
        breadcrumb: true,
        moduleKey: MODULES.REGIONAL_OFFICE,
        permissionId: PERMISSIONS.SHOW,
        icon: "",
        submenu: [],
      },
      {
        key: "additional-office-list",
        path: `${APP_PREFIX_PATH}/additional-office/list`,
        title: "additional.office.display",
        breadcrumb: true,
        moduleKey: MODULES.REGIONAL_OFFICE,
        permissionId: PERMISSIONS.SHOW,
        icon: "",
        submenu: [],
      },
    ],
  },
];
const serviceToolsTree = [
  {
    key: "services-tools",
    path: `${APP_PREFIX_PATH}/services-tools`,
    title: "services.tools",
    breadcrumb: true,
    icon: ToolOutlined,
    submenu: [
      {
        key: "services-tools-list",
        path: `${APP_PREFIX_PATH}/services-tools/list`,
        title: "services.tools.list",
        breadcrumb: true,
        moduleKey: MODULES.SERVICES_TOOLS,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "services-tools-calendar",
        path: `${APP_PREFIX_PATH}/services-tools/calendar`,
        title: "calendar",
        breadcrumb: false,
        moduleKey: MODULES.CALENDARS,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
    ],
  },
];
const settingsNavTree = [
  {
    key: "settings",
    path: `${APP_PREFIX_PATH}`,
    title: "settings",
    icon: SettingOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "capmas-sectors",
        path: `${APP_PREFIX_PATH}/capmas-sectors`,
        title: "capmas-sectors",
        breadcrumb: true,
        moduleKey: MODULES.SECTOR,
        permissionId: PERMISSIONS.SHOW,
        icon: UnorderedListOutlined,
        submenu: [],
      },
      {
        key: "departments",
        path: `${APP_PREFIX_PATH}/departments/list`,
        title: "departments",
        icon: ClusterOutlined,
        breadcrumb: true,
        moduleKey: MODULES.DEPARTMENTS,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      // {
      //   key: "user-list",
      //   path: `${APP_PREFIX_PATH}/users/list`,
      //   title: "user.list",
      //   breadcrumb: true,
      //   moduleKey: MODULES.USERS,
      //   permissionId: PERMISSIONS.SHOW,
      //   icon: UserOutlined,
      //   submenu: [],
      // },
      {
        key: "admin-user-list",
        path: `${APP_PREFIX_PATH}/admin-users/list`,
        title: "admin.user.list",
        breadcrumb: true,
        moduleKey: MODULES.USERS,
        permissionId: PERMISSIONS.SHOW,
        icon: UserOutlined,
        submenu: [],
      },
      {
        key: "end-user-list",
        path: `${APP_PREFIX_PATH}/end-users/list`,
        title: "end-user-list",
        breadcrumb: true,
        moduleKey: MODULES.USERS,
        permissionId: PERMISSIONS.SHOW,
        icon: UserOutlined,
        submenu: [],
      },
      {
        key: "subscriptions-list",
        path: `${APP_PREFIX_PATH}/subscription-users/list`,
        title: "subscriptions",
        breadcrumb: true,
        moduleKey: MODULES.USERS,
        permissionId: PERMISSIONS.SHOW,
        icon: FormOutlined,
        submenu: [],
      },
      {
        key: "role",
        path: `${APP_PREFIX_PATH}/roles/list`,
        title: "roles",
        icon: LockOutlined,
        breadcrumb: true,
        moduleKey: MODULES.ROLES,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "general-setting",
        path: `${APP_PREFIX_PATH}/settings/general-settings`,
        title: "general.settings",
        icon: SettingOutlined,
        breadcrumb: true,
        moduleKey: MODULES.SETTINGS,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "profile",
        path: `${APP_PREFIX_PATH}/profile`,
        title: "sidenav.pages.profile",
        icon: ProfileOutlined,
        breadcrumb: false,
        submenu: [],
      },
      // {
      //   key: "languages-list",
      //   path: `${APP_PREFIX_PATH}/languages/list`,
      //   title: "languages",
      //   breadcrumb: true,
      //   icon: GlobalOutlined,
      //   submenu: [],
      // },
    ],
  },
];
const formsNavTree = [
  {
    key: "forms",
    path: `${APP_PREFIX_PATH}/forms`,
    title: "forms",
    icon: FormOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "request-data-form",
        path: `${APP_PREFIX_PATH}/datarequest/list`,
        title: "request.data.form",
        breadcrumb: true,
        moduleKey: MODULES.DATAREQUEST,
        permissionId: PERMISSIONS.SHOW,
        icon: "",
        submenu: [],
      },
      {
        key: "request-documentation-microfilm",
        path: `${APP_PREFIX_PATH}/microfilm/list`,
        title: "request.documentation.microfilm",
        breadcrumb: true,
        moduleKey: MODULES.MICROFILM,
        permissionId: PERMISSIONS.SHOW,
        icon: "",
        submenu: [],
      },
      {
        key: "request-documentation-nationalCenter",
        path: `${APP_PREFIX_PATH}/national-center/list`,
        title: "request.documentation.nationalCenter",
        breadcrumb: true,
        moduleKey: MODULES.TRAINING_REQUEST,
        permissionId: PERMISSIONS.SHOW,
        icon: "",
        submenu: [],
      },
      // {
      //   key: "request-data-form-builder",
      //   path: `${APP_PREFIX_PATH}/form-builder/add`,
      //   title: "request.data.builder",
      //   breadcrumb: true,
      //   icon: "",
      //   submenu: [],
      // },
      // {
      //   key: "request-documentation-microfilm-builder",
      //   path: `${APP_PREFIX_PATH}/form-builder/list`,
      //   title: "request.documentation.builder",
      //   breadcrumb: true,
      //   icon: "",
      //   submenu: [],
      // },
    ],
  },
];

const data = [
  {
    key: "data",
    path: `${APP_PREFIX_PATH}/data/main-topics`,
    title: "data",
    icon: DatabaseOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "topics",
        path: `${APP_PREFIX_PATH}/data/main-topics/list`,
        title: "topics",
        breadcrumb: false,
        moduleKey: MODULES.SUBJECTS,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
    ],
  },
];

const dataQualityNavTree = [
  {
    key: "data-quality",
    path: `${APP_PREFIX_PATH}/data-quality`,
    title: "data.quality.and.validation",
    icon: SafetyCertificateOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "data-quality-overview",
        path: `${APP_PREFIX_PATH}/data-quality`,
        title: "data.quality.overview",
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "data-quality-chart-data",
        path: `${APP_PREFIX_PATH}/data-quality/chart-data`,
        title: "data.quality.chart.data",
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "data-quality-anomalies",
        path: `${APP_PREFIX_PATH}/data-quality/anomalies`,
        title: "data.quality.anomalies",
        breadcrumb: true,
        submenu: [],
      },
      // {
      //   key: "data-quality-validation",
      //   path: `${APP_PREFIX_PATH}/data-quality/validation`,
      //   title: "data.quality.validation",
      //   breadcrumb: true,
      //   submenu: [],
      // },
      // {
      //   key: "data-quality-missing-values",
      //   path: `${APP_PREFIX_PATH}/data-quality/missing-values`,
      //   title: "data.quality.missing.values",
      //   breadcrumb: true,
      //   submenu: [],
      // },
      // {
      //   key: "data-quality-subindicator",
      //   path: `${APP_PREFIX_PATH}/data-quality/subindicator`,
      //   title: "data.quality.subindicator.view",
      //   breadcrumb: true,
      //   submenu: [],
      // },
      // {
      //   key: "data-quality-main-indicator",
      //   path: `${APP_PREFIX_PATH}/data-quality/main-indicator`,
      //   title: "data.quality.main.indicator.view",
      //   breadcrumb: true,
      //   submenu: [],
      // },
    ],
  },
];

const indicators = [
  {
    key: "indicators",
    path: `${APP_PREFIX_PATH}/indicators`,
    title: "indicators",
    icon: ShrinkOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "main-indicators-list",
        path: `${APP_PREFIX_PATH}/main-indicators/list`,
        title: "main-indicators-list",
        breadcrumb: true,
        moduleKey: MODULES.INDICATORS,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "sub-indicators-list",
        path: `${APP_PREFIX_PATH}/sub-indicators/list`,
        title: "sub-indicators-list",
        breadcrumb: true,
        moduleKey: MODULES.FILTERS,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "selected-indicators-list",
        path: `${APP_PREFIX_PATH}/selected-indicators/list`,
        title: "selected-indicators-list",
        breadcrumb: true,
        moduleKey: MODULES.SELECTED_INDICATORS,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "pinned-indicators-list",
        path: `${APP_PREFIX_PATH}/pinned-indicators/list`,
        title: "pinned.indicators.list",
        breadcrumb: true,
        moduleKey: MODULES.SELECTED_INDICATORS,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "sort-indicators-list",
        path: `${APP_PREFIX_PATH}/main-indicators/sort`,
        title: "sort.indicators.list",
        breadcrumb: true,
        moduleKey: MODULES.INDICATORS,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
    ],
  },
];

const publications = [
  {
    key: "publications",
    path: `${APP_PREFIX_PATH}/publications`,
    title: "publications",
    icon: SnippetsOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "publications-list",
        path: `${APP_PREFIX_PATH}/publications/list`,
        title: "publications.list",
        breadcrumb: false,
        moduleKey: MODULES.PUBLICATIONS,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "publications-type-list",
        path: `${APP_PREFIX_PATH}/publications-type/list`,
        title: "publications.type.list",
        breadcrumb: false,
        moduleKey: MODULES.PUBLICATIONS_TYPE,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "publications-versions-list",
        path: `${APP_PREFIX_PATH}/publications-versions/list`,
        title: "publication.versions.list",
        breadcrumb: false,
        moduleKey: MODULES.PUBLICATIONS,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "entering-publication-data",
        path: `${APP_PREFIX_PATH}/entering-publication-data`,
        title: "entering.publication.data",
        breadcrumb: false,
        moduleKey: MODULES.PUBLICATIONS,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "publications-versions-migrate",
        path: `${APP_PREFIX_PATH}/publications-versions/migrate`,
        title: "publication.versions.migrate",
        //icon: InfoCircleOutlined,
        breadcrumb: false,
        moduleKey: MODULES.PUBLICATIONS_TYPE,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "publications-evidenceAndClassification-list",
        path: `${APP_PREFIX_PATH}/publications-evidenceAndClassification/list`,
        title: "publications.evidenceAndClassification",
        breadcrumb: false,
        moduleKey: MODULES.PUBLICATIONS_TYPE,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "publications-subscriptions-list",
        path: `${APP_PREFIX_PATH}/publications-subscriptions/list`,
        title: "publications.subscription",
        breadcrumb: false,
        moduleKey: MODULES.PUBLICATIONS_TYPE,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "measure-units-list",
        path: `${APP_PREFIX_PATH}/measure-units/list`,
        title: "measure.units.list",
        breadcrumb: false,
        moduleKey: MODULES.MEASURE_UNITS,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
    ],
  },
];
const newsTree = [
  {
    key: "new",
    path: `${APP_PREFIX_PATH}/new`,
    title: "new",
    icon: SnippetsOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "important-gates",
        path: `${APP_PREFIX_PATH}/gates/list`,
        title: "important-gates",
        breadcrumb: false,
        icon: ExceptionOutlined,
        moduleKey: MODULES.IMPORTANTPORTAL,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "censuses",
        path: `${APP_PREFIX_PATH}/censuses/list`,
        title: "censuses",
        breadcrumb: false,
        icon: RadarChartOutlined,
        moduleKey: MODULES.SURVEYCENSUSE,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "happening-now",
        path: `${APP_PREFIX_PATH}/happening-now/list`,
        title: "happening-now",
        breadcrumb: false,
        icon: FieldTimeOutlined,
        moduleKey: MODULES.HAPPENING_NOW,
        permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
    ],
  },
];
const surveyTree = [
  {
    key: "survey",
    path: `${APP_PREFIX_PATH}/survey/list`,
    title: "survey",
    icon: SnippetsOutlined,
    moduleKey: MODULES.SURVEY,
    permissionId: PERMISSIONS.SHOW,
    breadcrumb: false,
    submenu: [],
  },
];
const chatbotTree = [
  {
    key: "chatbot",
    path: `${APP_PREFIX_PATH}/chatbot`,
    title: "chatbot",
    icon: RobotOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "chatbot-analytics",
        path: `${APP_PREFIX_PATH}/chatbot/analytics/list`,
        title: "chatbot.analytics",
        breadcrumb: true,
        icon: RadarChartOutlined,
        // moduleKey: MODULES.CHATBOT,
        // permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "chatbot-liked-messages",
        path: `${APP_PREFIX_PATH}/chatbot/liked-messages/list`,
        title: "chatbot.liked.messages",
        breadcrumb: true,
        icon: LikeOutlined,
        // moduleKey: MODULES.CHATBOT,
        // permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "chatbot-disliked-messages",
        path: `${APP_PREFIX_PATH}/chatbot/disliked-messages/list`,
        title: "chatbot.disliked.messages",
        breadcrumb: true,
        icon: DislikeOutlined,
        // moduleKey: MODULES.CHATBOT,
        // permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      // {
      //   key: "chatbot-disliked-answers",
      //   path: `${APP_PREFIX_PATH}/chatbot/disliked-answers/list`,
      //   title: "chatbot.disliked.answers",
      //   breadcrumb: true,
      //   icon: DislikeOutlined,
      //   // moduleKey: MODULES.CHATBOT,
      //   // permissionId: PERMISSIONS.SHOW,
      //   submenu: [],
      // },
      {
        key: "chatbot-conversations",
        path: `${APP_PREFIX_PATH}/chatbot/conversations/list`,
        title: "chatbot.conversations",
        breadcrumb: true,
        icon: MessageOutlined,
        // moduleKey: MODULES.CHATBOT,
        // permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "chatbot-faqs",
        path: `${APP_PREFIX_PATH}/chatbot/faqs/list`,
        title: "chatbot.faqs",
        breadcrumb: true,
        icon: QuestionCircleOutlined,
        // moduleKey: MODULES.CHATBOT,
        // permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "chatbot-popular-topics",
        path: `${APP_PREFIX_PATH}/chatbot/popular-topics/list`,
        title: "chatbot.popular.topics",
        breadcrumb: true,
        icon: FireOutlined,
        // moduleKey: MODULES.CHATBOT,
        // permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "chatbot-response-time",
        path: `${APP_PREFIX_PATH}/chatbot/response-time/list`,
        title: "chatbot.response.time",
        breadcrumb: true,
        icon: ClockCircleOutlined,
        // moduleKey: MODULES.CHATBOT,
        // permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      // {
      //   key: "chatbot-satisfaction",
      //   path: `${APP_PREFIX_PATH}/chatbot/satisfaction/list`,
      //   title: "chatbot.satisfaction",
      //   breadcrumb: true,
      //   icon: SmileOutlined,
      //   // moduleKey: MODULES.CHATBOT,
      //   // permissionId: PERMISSIONS.SHOW,
      //   submenu: [],
      // },
      {
        key: "chatbot-peak-usage",
        path: `${APP_PREFIX_PATH}/chatbot/peak-usage/list`,
        title: "chatbot.peak.usage",
        breadcrumb: true,
        icon: FieldTimeOutlined,
        // moduleKey: MODULES.CHATBOT,
        // permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
      {
        key: "chatbot-top-users",
        path: `${APP_PREFIX_PATH}/chatbot/top-users/list`,
        title: "chatbot.top.users",
        breadcrumb: true,
        icon: UserIconOutlined,
        // moduleKey: MODULES.CHATBOT,
        // permissionId: PERMISSIONS.SHOW,
        submenu: [],
      },
    ],
  },
];

const navigationConfig = [
  ...dashBoardNavTree,
  ...homeNavTree,
  ...mediaCenterTree,
  ...aboutCapmasTree,
  ...contactUsTree,
  ...serviceToolsTree,
  ...publications,
  ...data,
  ...dataQualityNavTree,
  ...indicators,
  ...formsNavTree,
  ...adminNavTree,
  ...newsTree,
  ...settingsNavTree,
  ...surveyTree,
  ...chatbotTree,
];

export default navigationConfig;
